<template>
  <textarea 
    :class="options.css_classes" 
    :id="'field-' + options.id" 
    :name="'field-' + options.id" 
    v-model="fieldValue">
  </textarea>
</template>

<script>
export default { 
  name: 'TextareaField',
  props: {
    options: {
      type: Object,
      required: true
    },
    value: {
      type: String
    }
  },
  methods: {
    validate () {
      if (this.value && this.value != '') {
        return true
      }
      return false
    }
  },
  computed: {
    fieldValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$commit.setFieldValue({
          key: 'field-' + this.options.id, 
          value: val
        })
      }
    }
  }
}
</script>
